import { defaultTheme } from 'gd-design-library';
import { font } from './font';

export const accordion = {
  ...defaultTheme.accordion,
  header: {
    ...defaultTheme.accordion.header,
    default: {
      ...defaultTheme.accordion.header.default,
      padding: '16px 0',
      fontSize: '16px',
      fontWeight: '600',
      fontFamily: font.family,
      '&:hover': {
        ...defaultTheme.accordion.header.default['&:hover'],
        backgroundColor: 'transparent'
      }
    }
  },
  content: {
    ...defaultTheme.accordion.content,
    opened: {
      ...defaultTheme.accordion.content.opened,
      paddingTop: '0'
    },
    closed: {
      ...defaultTheme.accordion.content.closed,
      paddingTop: '0'
    }
  }
};
